import { useDiscountDescriptor } from 'routes/Menu/components/BoxSummary/Banner/PriceAndDiscountTip/priceAndDiscountTipUtils'

import { formatDiscountTip } from './discountAppliedBarUtils'

export const useDiscountAppliedData = () => {
  const discountDescriptor = useDiscountDescriptor()
  const { isDiscountEnabled } = discountDescriptor
  const discountTip = formatDiscountTip(discountDescriptor)

  return {
    discountTip,
    isDiscountEnabled,
  }
}
